// AUTO-GENERATED GraphQL Builder for OfferingPackage
import * as Builders from '../';
export class OfferingPackageBuilder {
  private s:string[]=[]; private r:string[]=[]; private v=new Set<string>(); depth=0;
  private add(f:string){ if(!this.s.includes(f)) this.s.push(f); return this; }
  getSelections(){ return [...this.s]; }
  toSelectionSet(){ const a=[...this.s,...this.r]; if(!a.length)return`{ id }`; return`{\n  ${a.join("\n  ")}\n}`;}
  guid(){ return this.add('guid'); }
  offeringId(){ return this.add('offeringId'); }
  name(){ return this.add('name'); }
  basePrice(){ return this.add('basePrice'); }
  extraPerHead(){ return this.add('extraPerHead'); }
  chooseCount(){ return this.add('chooseCount'); }
  sortOrder(){ return this.add('sortOrder'); }
  id(){ return this.add('id'); }
  isDeleted(){ return this.add('isDeleted'); }
  createdBy(){ return this.add('createdBy'); }
  createdDate(){ return this.add('createdDate'); }
  updatedBy(){ return this.add('updatedBy'); }
  updatedDate(){ return this.add('updatedDate'); }

  createdByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('createdByUser'))return this;
    this.v.add('createdByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`createdByUser { ${inner} }`);
    return this;
  }

  offering(b?:(q:Builders.OfferingBuilder)=>void){
    if(this.depth>=5||this.v.has('offering'))return this;
    this.v.add('offering');
    const n=new Builders.OfferingBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offering { ${inner} }`);
    return this;
  }

  updatedByUser(b?:(q:Builders.UserBuilder)=>void){
    if(this.depth>=5||this.v.has('updatedByUser'))return this;
    this.v.add('updatedByUser');
    const n=new Builders.UserBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`updatedByUser { ${inner} }`);
    return this;
  }

  bookingPackageByBundleOfferingPackageList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageByBundleOfferingPackageList'))return this;
    this.v.add('bookingPackageByBundleOfferingPackageList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageByBundleOfferingPackageList { ${inner} }`);
    return this;
  }

  bookingPackageByOfferingPackageList(b?:(q:Builders.BookingPackageBuilder)=>void){
    if(this.depth>=5||this.v.has('bookingPackageByOfferingPackageList'))return this;
    this.v.add('bookingPackageByOfferingPackageList');
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageByOfferingPackageList { ${inner} }`);
    return this;
  }

  offeringIncludeList(b?:(q:Builders.OfferingIncludeBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringIncludeList'))return this;
    this.v.add('offeringIncludeList');
    const n=new Builders.OfferingIncludeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringIncludeList { ${inner} }`);
    return this;
  }

  offeringMilestoneList(b?:(q:Builders.OfferingMilestoneBuilder)=>void){
    if(this.depth>=5||this.v.has('offeringMilestoneList'))return this;
    this.v.add('offeringMilestoneList');
    const n=new Builders.OfferingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringMilestoneList { ${inner} }`);
    return this;
  }

  packageItemByOfferingPackageList(b?:(q:Builders.PackageItemBuilder)=>void){
    if(this.depth>=5||this.v.has('packageItemByOfferingPackageList'))return this;
    this.v.add('packageItemByOfferingPackageList');
    const n=new Builders.PackageItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageItemByOfferingPackageList { ${inner} }`);
    return this;
  }

  packageItemBySrcOfferingPackageList(b?:(q:Builders.PackageItemBuilder)=>void){
    if(this.depth>=5||this.v.has('packageItemBySrcOfferingPackageList'))return this;
    this.v.add('packageItemBySrcOfferingPackageList');
    const n=new Builders.PackageItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageItemBySrcOfferingPackageList { ${inner} }`);
    return this;
  }

  packageOptionList(b?:(q:Builders.PackageOptionBuilder)=>void){
    if(this.depth>=5||this.v.has('packageOptionList'))return this;
    this.v.add('packageOptionList');
    const n=new Builders.PackageOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageOptionList { ${inner} }`);
    return this;
  }

  resaleList(b?:(q:Builders.ResaleBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleList'))return this;
    this.v.add('resaleList');
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  resaleTermList(b?:(q:Builders.ResaleTermBuilder)=>void){
    if(this.depth>=5||this.v.has('resaleTermList'))return this;
    this.v.add('resaleTermList');
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }

  reverseBookingPackage(b?:(q:Builders.BookingPackageBuilder)=>void){
    const n=new Builders.BookingPackageBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`bookingPackageList { ${inner} }`);
    return this;
  }

  reverseOfferingInclude(b?:(q:Builders.OfferingIncludeBuilder)=>void){
    const n=new Builders.OfferingIncludeBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringIncludeList { ${inner} }`);
    return this;
  }

  reverseOfferingMilestone(b?:(q:Builders.OfferingMilestoneBuilder)=>void){
    const n=new Builders.OfferingMilestoneBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`offeringMilestoneList { ${inner} }`);
    return this;
  }

  reversePackageItem(b?:(q:Builders.PackageItemBuilder)=>void){
    const n=new Builders.PackageItemBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageItemList { ${inner} }`);
    return this;
  }

  reversePackageOption(b?:(q:Builders.PackageOptionBuilder)=>void){
    const n=new Builders.PackageOptionBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`packageOptionList { ${inner} }`);
    return this;
  }

  reverseResale(b?:(q:Builders.ResaleBuilder)=>void){
    const n=new Builders.ResaleBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleList { ${inner} }`);
    return this;
  }

  reverseResaleTerm(b?:(q:Builders.ResaleTermBuilder)=>void){
    const n=new Builders.ResaleTermBuilder(); n.depth=this.depth+1;
    if(b)b(n);
    const inner=n.toSelectionSet().replace(/^\{|\}$/g,'').trim();
    this.r.push(`resaleTermList { ${inner} }`);
    return this;
  }
}
